import {DATE_FORMAT_SHOW} from "../../../../../utils/constants"
import {formatValue, renderCellWithTooltip} from "../../Utils/precos-pu-tir-constants"
import dayjs from "dayjs"

export const columnsPrecoVariacaoDiaria = () => [
    {
        field: "CETIP",
        headerName: "CETIP",
        flex: 1,
        minWidth: 200,
        renderCell: renderCellWithTooltip
    },
    {
        field: "DataReferencia",
        headerName: "Data Referência",
        minWidth: 150,
        type: "date",
        valueFormatter: (params) => (params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ""),
    },
    {
        field: "VNAPUPAR",
        headerName: "VNA",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "AtualizacaoMonetariaIncrementoPUPAR",
        headerName: "Atualização Monetária Incremento",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "JurosAcruadosPUPAR",
        headerName: "Juros Acruados",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "TaxaRiskFreeAnterior",
        headerName: "Taxa RiskFree Anterior",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "TaxaRiskFreeAtual",
        headerName: "Taxa RiskFree Atual",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "DeltaRiskFree",
        headerName: "Delta RiskFree",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "SpreadCreditoAnterior",
        headerName: "Spread Crédito Anterior",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "SpreadCreditoAtual",
        headerName: "Spread Crédito Atual",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "DeltaSpreadCredito",
        headerName: "Delta Spread Crédito",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "AjusteMTMDiario",
        headerName: "Ajuste MTM Diário",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "AmortizacaoOrdinariaPUPAR",
        headerName: "Amortização Ordinária",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "AmortizacaoExtraordinariaPUPAR",
        headerName: "Amortização Extraordinária",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "JurosPUPAR",
        headerName: "Cupom Juros",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "IncorporacaoJurosPUPAR",
        headerName: "Incorporação de Juros",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "PremioPUPAR",
        headerName: "Prêmio",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "PagamentoPUPAR",
        headerName: "Pagamento",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "DataEventoProximo",
        headerName: "Data Próximo Evento",
        minWidth: 150,
        type: "date",
        valueFormatter: (params) => (params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ""),
    },
    {
        field: "ClassificacaoProximoEvento",
        headerName: "Próximo Evento",
        flex: 1,
        minWidth: 200,
        renderCell: renderCellWithTooltip
    },
    {
        field: "ValorProximoEvento",
        headerName: "Valor do Próximo Evento",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "PUPARAnterior",
        headerName: "PUPAR Anterior",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "PUPARAtual",
        headerName: "PUPAR Atual",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "DeltaPUPAR",
        headerName: "Delta PUPAR",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "VarPUPAR",
        headerName: "%Var PUPAR",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "PU_MTMAnterior",
        headerName: "PU MTM Anterior",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "PU_MTMAtual",
        headerName: "PU MTM Atual",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "DeltaPU_MTM",
        headerName: "Delta PU MTM",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "IndiceDivergencia",
        headerName: "Índice Divergência",
        type: "number",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "VarPUMTM",
        headerName: "%Var PU MTM",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => formatValue(params)
    },
    {
        field: "JustificativaPUPAR",
        headerName: "Justificativa PUPAR",
        flex: 1,
        minWidth: 200,
        renderCell: renderCellWithTooltip
    },
    {
        field: "JustificativaPUMTM",
        headerName: "Justificativa PU MTM",
        flex: 1,
        minWidth: 200,
        renderCell: renderCellWithTooltip
    },
]